import React from "react";

import { observer } from "mobx-react";

import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import OfferIcon from "@components/icons/Offer";

export const CategoryItemIcon = observer(function CategoryItemIcon(props: {
	category: PrematchOfferMenuStore["menu"];
}) {
	if (
		props.category.node.isTopTournament &&
		props.category.children.length == 0
	) {
		return (
			<OfferIcon
				type={"tournament"}
				sport={props.category.node.sportAbrv || ""}
				category={props.category.node.categoryAbrv || ""}
				tournament={props.category.node.abrv || ""}
				treeIcon={true}
				wrapperClassName="nav--tertiary__icon u-icon u-icon--base"
				className="nav--tertiary__icon__inner u-icon--base"
			/>
		);
	}

	return (
		<OfferIcon
			type={props.category.node.isTopTournament ? "sport" : "category"}
			sport={
				props.category.node.isTopTournament
					? props.category.node.abrv || ""
					: props.category.parent?.node.abrv || ""
			}
			category={props.category.node.abrv || ""}
			treeIcon={true}
			wrapperClassName="nav--tertiary__icon u-icon u-icon--base"
			className="nav--tertiary__icon__inner u-icon--base"
		/>
	);
});
